import cashDeskInstance from './instance'

const deleteClientMonitorCart = (desktopDeviceId) => {
	return cashDeskInstance.delete(`/cartState/${desktopDeviceId}`)
}

export default deleteClientMonitorCart
